import { Component, Input, SimpleChanges, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EmailService } from '../email/email.service';
import { HttpErrorResponse } from '@angular/common/http';

export interface Sms {
  messageBody: string;
}

@Component({
  selector: 'ag-send-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SmsComponent implements OnChanges {
  @Input() sms: Sms;

  smsForm: UntypedFormGroup;
  phoneNumber: number;
  row = 5;

  constructor(
    private _fb: UntypedFormBuilder,
    private _snackBar: MatSnackBar,
    private _emailService: EmailService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sms) {
      this.sms = changes.sms.currentValue;
      if (this.sms) {
        this.smsForm = this._fb.group({
          phoneNumber: [
            this.phoneNumber,
            [
              Validators.required,
              Validators.minLength(10),
              Validators.maxLength(10),
              Validators.pattern('[0-9]+'),
            ],
          ],
          messageBody: [`${this.sms.messageBody}`, Validators.required],
        });
      }
    }
  }

  sendSMS(data) {
    data.value = this.smsForm.getRawValue();
    this._emailService.sendSms(data.value).subscribe({
      next: (response) => {
        this._snackBar.open(response, '', { duration: 4000 });
      },
      error: (err: unknown) => {
        if (err instanceof HttpErrorResponse) {
          this._snackBar.open(err.error || 'SMS failed to send.', '', { duration: 4000 });
        }
      },
    });
  }
}
